import { render, staticRenderFns } from "./AssetTableNotes.vue?vue&type=template&id=09ed80ee&"
import script from "./AssetTableNotes.vue?vue&type=script&lang=js&"
export * from "./AssetTableNotes.vue?vue&type=script&lang=js&"
import style0 from "./AssetTableNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports